import { render } from "./VerticalFeedList.vue?vue&type=template&id=cb1aa7d8"
import script from "./VerticalFeedList.vue?vue&type=script&lang=js"
export * from "./VerticalFeedList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__